var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgApplicant(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h16v16H0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.254 13.515H2.576A.576.576 0 0 1 2 12.94v-2.303a2.303 2.303 0 0 1 2.303-2.303h1.152c.152 0 .299.061.407.169l1.32 1.32v1.39a.574.574 0 0 1-.407-.169L5.216 9.485h-.913c-.636 0-1.151.515-1.151 1.151v1.728h4.03v.575c0 .2.025.392.072.576zm2.749-8.06h-.518c-.251 0-.493.04-.72.114a1.727 1.727 0 1 0-1.258 1.006c-.206.346-.325.75-.325 1.183a2.879 2.879 0 1 1 2.821-2.303zm.058 1.151h2.878c.954 0 1.728.773 1.728 1.727v4.606c0 .954-.774 1.728-1.728 1.728h-2.878a1.727 1.727 0 0 1-1.728-1.728V8.333c0-.954.774-1.727 1.728-1.727zm0 1.152a.576.576 0 0 0-.576.575v4.606c0 .318.258.576.576.576h2.878a.576.576 0 0 0 .576-.576V8.333a.576.576 0 0 0-.576-.575h-2.878zm.575 1.727a.576.576 0 0 1 0-1.152h1.728a.576.576 0 0 1 0 1.152h-1.728zm0 1.727a.576.576 0 0 1 0-1.151h1.728a.576.576 0 0 1 0 1.151h-1.728zm0 1.727a.576.576 0 1 1 0-1.151h1.728a.576.576 0 0 1 0 1.151h-1.728z",
    fill: "#8CAEB4"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApplicant);
export default __webpack_public_path__ + "static/media/applicant.cf1c1a2ba3bc07340bfbda8983bb9ba5.svg";
export { ForwardRef as ReactComponent };